import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import {blue, grey} from '@mui/material/colors'
import {useNavigate} from 'react-router-dom'

export default function AdminWrapper({children}: {children: React.ReactNode}) {
  const navigate = useNavigate()
  return (
    <>
      <Box bgcolor={grey[100]} p={1} display={'flex'} gap={4} color={blue[900]}>
        <Button color={'inherit'} variant={'contained'} onClick={() => navigate('/admin')}>
          Admin Home
        </Button>
        <Button color={'inherit'} variant={'contained'} onClick={() => navigate('/admin/graph')}>
          Graph Management
        </Button>
        <Button color={'inherit'} variant={'contained'} onClick={() => navigate('/admin/api_log')}>
          API Log
        </Button>
        <Button
          color={'inherit'}
          variant={'contained'}
          onClick={() => navigate('/account/settings')}
        >
          Account Settings
        </Button>
      </Box>
      {children}
    </>
  )
}
